import React, { useState, useEffect, useContext } from "react";
import { reportTypesService } from "../../services/reportTypes";
import { Table } from "./components/Table";
import { useDebounce, useFetch } from "../../utils/hooks";
import styles from "../styles/Registers.module.css";
import { Heading } from "./components/Heading";
import { AddOrEditReportType } from "./components/AddOrEditReportType";
import { OrdinationsAndCountriesContext } from "../../contexts/ordinationsAndCountriesContext";

export const ReportTypes = () => {
  const loadingSelectData = false;
  const [searchValue, setSearchValue] = useState("");
  const [orderValue, setOrderValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const size = localStorage.getItem("pageSizeReportTypes")
    ? localStorage.getItem("pageSizeReportTypes")
    : 20;
  const [pageSize, setPageSize] = useState(size);
  const [visibleReportTypeModal, setVisibleReportTypeModal] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue);
  const { ordinationId } = useContext(OrdinationsAndCountriesContext);

  const loadReportTypes = (cancelToken) =>
    reportTypesService.getReportTypesPaged({
      currentPage,
      pageSize,
      searchValue: debouncedSearchValue,
      cancelToken,
      orderValue,
    });

  const [
    {
      data: { results: reportTypes, count: totalRows },
      isFetching,
    },
    getReportTypes,
  ] = useFetch(loadReportTypes);

  const loading = ordinationId === undefined || isFetching || loadingSelectData;

  useEffect(() => {
    setCurrentPage(1);
    setOrderValue("");
  }, [debouncedSearchValue]);

  useEffect(() => {
    getReportTypes();
  }, [
    OrdinationsAndCountriesContext,
    debouncedSearchValue,
    pageSize,
    currentPage,
    getReportTypes,
    orderValue,
    ordinationId,
  ]);

  return (
    <div className={styles.registers}>
      <h1>Pregledi</h1>

      <div //className={styles.medicalReportFormBoxes}
      >
        <Heading
          searchValue={searchValue}
          onSearch={(search) => setSearchValue(search)}
          onCreateReportTypeClicked={() => setVisibleReportTypeModal(true)}
        />
        <Table
          reportTypes={reportTypes}
          loading={loading}
          totalRows={totalRows}
          currentPage={currentPage}
          pageSize={pageSize}
          onClone={getReportTypes}
          onEdit={getReportTypes}
          onDelete={getReportTypes}
          orderValue={orderValue}
          setOrderValue={(order) => setOrderValue(order)}
          onPaginationChange={(page) => setCurrentPage(page)}
          onPageSizeChange={(size) => {
            setCurrentPage(1);
            setPageSize(size);
            localStorage.setItem("pageSizeReportTypes", size);
          }}
        />
      </div>
      <AddOrEditReportType
        visibleModal={visibleReportTypeModal}
        onCloseModal={() => setVisibleReportTypeModal(false)}
        onAddReportType={getReportTypes}
      />
    </div>
  );
};
